import { usePermissions } from "../hooks/usePermissions";

/**
 * Route-level access guard.
 *
 * ⚠️⚠️ Before Sep 10, 2026 the app had NO route guards at all — hiding a nav
 * entry was the whole frontend gate, so a technician could reach /jobs simply
 * by typing the URL. That made "which sections can this role see?" unanswerable
 * in any real sense, which is why the Roles feature needed this.
 *
 * ⚠️ This is UX, not security. The server is still the boundary: every
 * endpoint does its own `require_permission`, and the permission this checks
 * is the *section* marker, which is deliberately separate from the API read
 * permission (see auth/sections.py).
 */
export default function RequirePermission({ perm, children }) {
  const { can } = usePermissions();
  if (can(perm)) return children;
  return (
    <div className="p-4">
      <p className="text-sm text-ink-muted">
        You don't have access to this section. Ask a system administrator if you need it.
      </p>
    </div>
  );
}
